const SCOPED_APPLICATION_ID_PATTERN =
  /^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:::(A|B))?$/i;

function normalizeScopedApplicationIdForKey(value: string): string {
  const match = SCOPED_APPLICATION_ID_PATTERN.exec(value.trim());
  if (!match?.[1]) return value.trim();
  const side = match[2] ? `::${match[2].toUpperCase()}` : "";
  return `${match[1].toLowerCase()}${side}`;
}

/** Stable key for subset configure overrides sent to optimize (svc-10). */
export function configureGroupKey(
  productId: string,
  applicationIds: readonly string[],
): string {
  return `${productId}|${[...applicationIds]
    .map(normalizeScopedApplicationIdForKey)
    .sort()
    .join(",")}`;
}
